import axios from 'axios';

const TIMEOUT = 30000;

const requestInterceptor = (req) => {
  return req;
};

const responseInterceptor = (res) => {
  return res;
};

const createClient = ({ baseUrl, headers }) => {
  const axiosClient = axios.create({
    baseURL: baseUrl,
    headers: {
      ...headers,
    },
    timeout: TIMEOUT,
    withCredentials: true,
  });

  axiosClient.interceptors.request.use(requestInterceptor);
  axiosClient.interceptors.response.use(responseInterceptor);

  return axiosClient;
};

export default createClient;
